module.exports = __webpack_public_path__ + "img/liu.b8bee22d.png";